export default __webpack_public_path__ + "static/media/9.a2d6e75c.png";